module.exports = __webpack_public_path__ + "img/upload_wall_7.3bb831e5.webp";